import { Injectable } from "@angular/core";
import { Http, Response, Headers } from "@angular/http";
import { ConfigService } from "../../shared/services/config.service";
import { BaseService } from "../../shared/services/base.service";

import { Client } from "../models/client";
import { ClientDomain } from "../models/clientdomain";
import { DataStation } from "../models/datastation";
import { DataLink } from "../models/datalink";
import { Dashboard } from "app/visualis/models/dashboard";
import { SentinelServer } from "../models/sentinelserver";
import { SentinelDomain } from "../models/sentineldomain";
import { User } from "../models/user";

import { Observable } from "rxjs/Rx";

// Add the RxJS Observable operators we need in this app.
import "../../rxjs-operators";
import { DashComponent } from "../models/dashcomponent";
import { SentinelDomainSpecies } from "app/visualis/models/sentineldomainspecies";
import { SentinelDomainRun, SentinelForecast } from "app/visualis/models/sentineldomainrun";
import { SentinelImgInfo } from "app/visualis/models/sentinelimginfo";
import { SysConfig } from 'app/visualis/models/sysconfig';
import { VisualisDataset } from 'app/visualis/models/visualisdataset';
import { ComponentData_Header, ComponentData_Update } from 'app/visualis/models/componentdata';
import { SentinelDomainInfo } from '../models/sentineldomaininfo';
import { SentinelDomainExportModeled } from '../models/sentinelexportmodeled';
import { SentinelAlertReport } from '../models/sentinelalertreport';
import { environment } from 'environments/environment';
import { Language, LanguageConfig } from "../models/language";
import { EventEmitter } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { log_output } from "../models/log";

import { catchError, finalize } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
//import { LogService } from "./log.service";

@Injectable()
export class DataService extends BaseService {

  baseUrl: string = "";
  activeClient: Client;
  google_url : string = "";
  authToken = localStorage.getItem("auth_token");
  private is_loading = new BehaviorSubject<boolean>(false);
  // Método para actualizar la variable
  public start_loading() {this.is_loading.next(true)};
  public end_loading() {this.is_loading.next(false)};
  // Método para obtener la variable como un observable
  get_loading() {
    return this.is_loading.asObservable();
  }
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json',
      'Authorization': `Bearer ${this.authToken}`,
      "Access-Control-Allow-Origin": "*",
      'Access-Control-Allow-Headers': 'Content-Type'
    })
  };

  constructor(
    private http: Http,
    private configService: ConfigService,
    private http_client: HttpClient,
    //private log_service: LogService
    ) {
    super();
    this.baseUrl = configService.getApiURI();
    this.activeClient = null;
    this.google_url = environment.url_google;
  }
  //new log service--------------------------------------------------------------------------
  private get_text(proyect: string, document: string, method: string, typee: string, message: string){
    return `[${Date.now().toLocaleString()}][${typee}][${proyect}][${document}][${method}] ${message}`;
  }
  private procces(proyect: string, document: string, method: string, typee: string, message: string){
    //if(environment.showConsoleDebug == true){//mostrar log en pantalla
    let bool = false;
    //console.log("window.location.href: ", window.location.href);
    //console.log("this.router.url: ", this.router.url);
    try{
      if(bool){
        let text = this.get_text(proyect, document, method, typee, message);
      }
      else{//enviar log a google db
        let client = this.getActiveClient();
          let log = new log_output(proyect, document, method, typee, message, client == null? "general":client.name,
           "",// url vacio
          "SmartPlume");
          let url = this.google_url + "logservice-api";
          this.http_client.post<any>(
              url,
              log,
              this.httpOptions)
              .pipe(
                catchError(this.handleError)
          );
      }
    }
    catch{
      //console.log("catch in procces: ", e)
    }
  }
  protected handleError(error: any) {
    this.procces("webapp", "visualis.data.service.ts", "habdleError", "error", error);
    this.handleErrorBase(error);
    return Observable.throw('Server error');
  }
  //new log service--------------------------------------------------------------------------
  /*
  protected handleError(error: any) {
    this.log_service.error("webapp", "visualis.data.service.ts", "habdleError", error);
    return Observable.throw('Server error');
  }
  */
  // ==================================================================
  // Sentinel Servers
  // ==================================================================
  getSentinelServers(): Observable<SentinelServer[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);
    return this.http
      .get(this.baseUrl + "/sentinelserver/", { headers })
      .map((response: Response) => {
        return <SentinelServer[]>response.json();
      })
      .catch(this.handleError);
  }

  getSentinelServer(index: number): Observable<SentinelServer> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(this.baseUrl + "/sentinelserver/" + index, { headers })
      .map((response: Response) => {
        return <SentinelServer>response.json();
      })
      .catch(this.handleError);
  }

  addSentinelServer(server: SentinelServer): Observable<SentinelServer> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .post(this.baseUrl + "/sentinelserver/", server, { headers })
      .map((response: Response) => {
        return <SentinelServer>response.json();
      })
      .catch(this.handleError);
  }

  editSentinelServer(server: SentinelServer): Observable<SentinelServer> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .put(this.baseUrl + "/sentinelserver/" + server.id, server, { headers })
      .map((response: Response) => {
        return <SentinelServer>response.json();
      })
      .catch(this.handleError);
  }

  deleteSentinelServer(index): Observable<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .delete(this.baseUrl + "/sentinelserver/" + index, { headers })
      .map((response: Response) => {
        return response;
      })
      .catch(this.handleError);
  }

  // ==================================================================
  // Clients
  // ==================================================================
  getClients(): Observable<Client[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(this.baseUrl + "/client/", { headers })
      .map((response: Response) => {
        return <Client[]>response.json();
      })
      .catch(this.handleError);
  }

  setActiveClient(aClient: Client): void {
    this.activeClient = aClient;
  }

  getActiveClient(): Client {
    return this.activeClient;
  }

  getClient(index): Observable<Client> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(this.baseUrl + "/client/" + index, { headers })
      .map((response: Response) => {
        return <Client>response.json();
      })
      .catch(this.handleError);
  }

  addClient(client: Client): Observable<Client> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .post(this.baseUrl + "/client/", client, { headers })
      .map((response: Response) => {
        return <Client>response.json();
      })
      .catch(this.handleError);
  }

  editClient(client: Client): Observable<Client> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .put(this.baseUrl + "/client/" + client.id, client, { headers })
      .map((response: Response) => {
        return <Client>response.json();
      })
      .catch(this.handleError);
  }

  deleteClient(index): Observable<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .delete(this.baseUrl + "/client/" + index, { headers })
      .map((response: Response) => {
        return response;
      })
      .catch(this.handleError);
  }

  // ==================================================================
  // Client Domains
  // ==================================================================
  getClientDomains(clientindex): Observable<ClientDomain[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(this.baseUrl + "/clientdomain/forclient/" + clientindex, { headers })
      .map((response: Response) => {
        return <ClientDomain[]>response.json();
      })
      .catch(this.handleError);
  }

  getClientDomain(index): Observable<ClientDomain> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(this.baseUrl + "/clientdomain/" + index, { headers })
      .map((response: Response) => {
        return <ClientDomain>response.json();
      })
      .catch(this.handleError);
  }

  addClientDomain(domain: ClientDomain): Observable<ClientDomain> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .post(this.baseUrl + "/clientdomain/", domain, { headers })
      .map((response: Response) => {
        return <ClientDomain>response.json();
      })
      .catch(this.handleError);
  }

  editClientDomain(domain: ClientDomain): Observable<ClientDomain> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .put(this.baseUrl + "/clientdomain/" + domain.id, domain, { headers })
      .map((response: Response) => {
        return <ClientDomain>response.json();
      })
      .catch(this.handleError);
  }

  deleteClientDomain(index): Observable<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .delete(this.baseUrl + "/clientdomain/" + index, { headers })
      .map((response: Response) => {
        return response;
      })
      .catch(this.handleError);
  }

  // ==================================================================
  // Data Stations
  // ==================================================================
  getDataStationsClient(clientindex): Observable<DataStation[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(this.baseUrl + "/datastation/forclient/" + clientindex, { headers })
      .map((response: Response) => {
        return <DataStation[]>response.json();
      })
      .catch(this.handleError);
  }

  getDataStationsDomain(domainindex): Observable<DataStation[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(this.baseUrl + "/datastation/fordomain/" + domainindex, { headers })
      .map((response: Response) => {
        return <DataStation[]>response.json();
      })
      .catch(this.handleError);
  }

  getDataStation(index): Observable<DataStation> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(this.baseUrl + "/datastation/" + index, { headers })
      .map((response: Response) => {
        return <DataStation>response.json();
      })
      .catch(this.handleError);
  }

  sendISAP(index,icommand,nhours) {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(this.baseUrl + "/datastation/isapcommand/" + index+"/"+icommand+"/"+nhours, { headers })
      .map( response => response.text())
      .catch(this.handleError);
  }

  addDataStation(station: DataStation): Observable<DataStation> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .post(this.baseUrl + "/datastation/", station, { headers })
      .map((response: Response) => {
        return <DataStation>response.json();
      })
      .catch(this.handleError);
  }

  editDataStation(station: DataStation): Observable<DataStation> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .put(this.baseUrl + "/datastation/" + station.id, station, { headers })
      .map((response: Response) => {
        return <DataStation>response.json();
      })
      .catch(this.handleError);
  }

  deleteDataStation(index): Observable<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .delete(this.baseUrl + "/datastation/" + index, { headers })
      .map((response: Response) => {
        return response;
      })
      .catch(this.handleError);
  }

  // ==================================================================
  // Data Links
  // ==================================================================
  getDataLinksClient(clientindex): Observable<DataLink[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(this.baseUrl + "/datalink/forclient/" + clientindex, { headers })
      .map((response: Response) => {
        return <DataStation[]>response.json();
      })
      .catch(this.handleError);
  }

  getDataLinksDomain(domainindex): Observable<DataLink[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(this.baseUrl + "/datalink/fordomain/" + domainindex, { headers })
      .map((response: Response) => {
        return <DataStation[]>response.json();
      })
      .catch(this.handleError);
  }

  getDataLinksStation(domainindex): Observable<DataLink[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(this.baseUrl + "/datalink/fordomain/" + domainindex, { headers })
      .map((response: Response) => {
        return <DataLink[]>response.json();
      })
      .catch(this.handleError);
  }

  getDataLink(index): Observable<DataLink> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(this.baseUrl + "/datalink/" + index, { headers })
      .map((response: Response) => {
        return <DataLink>response.json();
      })
      .catch(this.handleError);
  }

  getDataLinkSampleData(index): Observable<VisualisDataset> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(this.baseUrl + "/datalink/sampledisplay/" + index, { headers })
      .map((response: Response) => {
        return <VisualisDataset>response.json();
      })
      .catch(this.handleError);
  }

  addDataLink(datalink: DataLink): Observable<DataLink> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .post(this.baseUrl + "/datalink/", datalink, { headers })
      .map((response: Response) => {
        return <DataLink>response.json();
      })
      .catch(this.handleError);
  }

  editDataLink(datalink: DataLink): Observable<DataLink> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .put(this.baseUrl + "/datalink/" + datalink.id, datalink, { headers })
      .map((response: Response) => {
        return <DataLink>response.json();
      })
      .catch(this.handleError);
  }

  deleteDataLink(index): Observable<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .delete(this.baseUrl + "/datalink/" + index, { headers })
      .map((response: Response) => {
        return response;
      })
      .catch(this.handleError);
  }

  // ================================================================== CarlosCastro
  // Dashboards
  // ================================================================== Buscando api pluma
  getDashboardsClient(clientindex): Observable<Dashboard[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(this.baseUrl + "/dashboard/forclient/" + clientindex, { headers })
      .map((response: Response) => {
        return <Dashboard[]>response.json();
      })
      .catch(this.handleError);
  }

  getDashboardsClientAdmin(clientindex): Observable<Dashboard[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(this.baseUrl + "/dashboard/forclientadmin/" + clientindex, { headers })
      .map((response: Response) => {
        return <Dashboard[]>response.json();
      })
      .catch(this.handleError);
  }


  getDashboard(index): Observable<Dashboard> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(this.baseUrl + "/dashboard/" + index, { headers })
      .map((response: Response) => {
        return <Dashboard>response.json();
      })
      .catch(this.handleError);
  }

  addDashboard(dashboard: Dashboard): Observable<Dashboard> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .post(this.baseUrl + "/dashboard/", dashboard, { headers })
      .map((response: Response) => {
        return <Dashboard>response.json();
      })
      .catch(this.handleError);
  }

  editDashboard(dashboard: Dashboard): Observable<Dashboard> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);
    //console.log("Sending Dash:",dashboard);
    return this.http
      .put(this.baseUrl + "/dashboard/" + dashboard.id, dashboard, { headers })
      .map((response: Response) => {
        return <Dashboard>response.json();
      })
      .catch(this.handleError);
  }

  deleteDashboard(index): Observable<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .delete(this.baseUrl + "/dashboard/" + index, { headers })
      .map((response: Response) => {
        return response;
      })
      .catch(this.handleError);
  }

  // ==================================================================
  // Dashboard Components
  // ==================================================================
  getComponents(dashindex): Observable<DashComponent[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(this.baseUrl + "/component/fordashboard/" + dashindex, { headers })
      .map((response: Response) => {
        return <DashComponent[]>response.json();
      })
      .catch(this.handleError);
  }

  getComponent(index): Observable<DashComponent> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(this.baseUrl + "/component/" + index, { headers })
      .map((response: Response) => {
        return <DashComponent>response.json();
      })
      .catch(this.handleError);
  }

  editComponent(component: DashComponent): Observable<DashComponent> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .put(this.baseUrl + "/component/" + component.id, component, { headers })
      .map((response: Response) => {
        return <DashComponent>response.json();
      })
      .catch(this.handleError);
  }

  getComponentHeader(index): Observable<ComponentData_Header> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);
    //console.log("url for client configuration: ", this.baseUrl + "/component/data_header/");
    return this.http
      .get(this.baseUrl + "/component/data_header/" + index, { headers })
      .map((response: Response) => {
        return <ComponentData_Header>response.json();
      })
      .catch(this.handleError);
  }

  /*
  * function that have the mission of deliver GeoJson for
  * drawing trajectories in UI (openLayer Map)
  */
  getTrayectories(params): Observable<any> {

    // --- update headers options
    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    // --- build and set header token
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    // --- update parametros for request
    var _controller = 'sentinelserver';
    var _method     = 'sentinel_gettrajectory';
    var _clientid   = params.clientid;
    var _serverid   = params.serverid;
    var _domainid   = params.domainid;
    var _lat        = params.lat;
    var _lon        = params.lon;
    var _tfrom      = params.tfrom;

    // --- build final url
    var _url = this.baseUrl + `/${_controller}/${_method}/${_clientid}/${_serverid}/${_domainid}/${_lat}/${_lon}/${_tfrom}`;

    // --- make request to api server
    //console.log("debug:request:getTrayectories", _url);
    return this.http
      .get(
        _url,
        { headers })
      .map((response: Response) => {
        var dataResult = <any>response.json();
        return dataResult;
      })
      .catch(this.handleError);
  }

  /*
  * function that returns specific parameter of
  * configuration for an domain in COS2/AdminWeb.
  */
  getCOS2DomainParameterOption(params): Observable<any> {

    // --- update headers options
    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    // --- build and set header token
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    // --- update parametros for request
    var _controller = 'cos2domain';
    var _method     = 'get_domain_var_config';
    var _serverid   = params.serverid || 0;
    var _domainid   = params.domainid || 0;
    var _key        = params.key || "";
    var _type       = params.type || 0;

    // --- build final url
    var _url = `${this.baseUrl}/${_controller}/${_method}/${_serverid}/${_domainid}/${_key}/${_type}`;

    // --- make request to api server
    //console.log("debug:request:getCOS2DomainParameterOption", _url);
    return this.http
      .get(
        _url,
        { headers })
      .map((response: Response) => {
        var dataResult = <any>response.json();
        return dataResult;
      })
      .catch(this.handleError);
  }

  getComponentUpdateFull(index,from,to,aggtype,aggperiod): Observable<ComponentData_Update> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);
    var url = this.baseUrl + "/component/data_update_full/" + index+"/"+from+"/"+to+"/"+aggtype+"/"+aggperiod;
    //console.log("CarlosCastro. getComponentUpdateFull.\n Url: ", url,
    //"\n UrlBruta: ", "this.baseUrl" + "/component/data_update_full/" + "index" +"/"+"from"+"/"+"to"+"/"+"aggtype"+"/"+"aggperiod",
    //"\n varibles: ", " BaseUrl: ", this.baseUrl + ". Index: ", index, ". From: ", from, ". To: ", to, ". AggType: ", aggtype, ". AggPeriod: ", aggperiod);
    //console.log("getComponentUpdateFull : "+this.baseUrl + "/component/data_update_full/"+index+"/"+from+"/"+to+"/"+aggtype+"/"+aggperiod);
    //console.log("* Before call data_update_full.. Updated CC");
    return this.http
      .get(url, { headers })
      .map((response: Response) => {
        //console.log("* Data_update_full OK..");
        //console.log(" response: ", <ComponentData_Update>response.json());
        return <ComponentData_Update>response.json();
      })
      .catch(this.handleError);
  }

  getComponentUpdateFullSmartSwitch(index,sId,from,to,aggtype,aggperiod): Observable<ComponentData_Update> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);
    var url = this.baseUrl + "/component/data_update_full_smartswitch/" + index+"/"+sId+"/"+from+"/"+to+"/"+aggtype+"/"+aggperiod;
    //console.log("CarlosCastro. getComponentUpdateFullSmartSwitch(). Url: ", url);
    return this.http
      .get(url, { headers })
      .map((response: Response) => {
        //console.log(response);
        return <ComponentData_Update>response.json();
      })
      .catch(this.handleError);
  }

  getComponentUpdate(index,from,to,aggtype,aggperiod): Observable<ComponentData_Update> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);
    var url = this.baseUrl + "/component/data_update/" + index+"/"+from+"/"+to+"/"+aggtype+"/"+aggperiod;
    //console.log("CarlosCastro. getComponentUpdate(). url: ", url);
    //console.log(this.baseUrl + "/component/data_update/"+index+"/"+from+"/"+to+"/"+aggtype+"/"+aggperiod);

    return this.http
      .get(url, { headers })
      .map((response: Response) => {
        return <ComponentData_Update>response.json();
      })
      .catch(this.handleError);
  }

  // ==================================================================
  // Users
  // ==================================================================
  getUsers(): Observable<User[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(this.baseUrl + "/accounts/", { headers })
      .map((response: Response) => {
        return <User[]>response.json();
      })
      .catch(this.handleError);
  }

  addUser(user: User): Observable<User> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .post(this.baseUrl + "/accounts/", user, { headers })
      .map((response: Response) => {
        //console.log("DataService Result : ", response);
        return <User>response.json();
      })
      .catch(this.handleError);
  }

  editUser(user: User): Observable<User> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .put(this.baseUrl + "/accounts/" + user.id, user, { headers })
      .map((response: Response) => {
        //console.log("DataService Result : ", response);
        return <User>response.json();
      })
      .catch(this.handleError);
  }

  deleteUser(user: User): Observable<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .delete(this.baseUrl + "/accounts/" + user.id, { headers })
      .map((response: Response) => {
        //console.log("DataService Result : ", response);
        return response;
      })
      .catch(this.handleError);
  }

  editUserPass(user: User): Observable<User> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .put(this.baseUrl + "/accounts/password/" + user.id, user, { headers })
      .map((response: Response) => {
        //console.log("DataService Result : ", response);
        return <User>response.json();
      })
      .catch(this.handleError);
  }

  // ==================================================================
  // Sentinel Server - WebAPI Classes
  // ==================================================================

  getSentinelDomains(serverid: number): Observable<SentinelDomain[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    // WE SHOULD FIX THIS SOON

    // let authToken = localStorage.getItem("auth_token");
    // headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(this.baseUrl + "/sentinelserver/sentinel_getdomains/" + serverid, {
        headers
      })
      .map((response: Response) => {
        return <SentinelDomain[]>response.json();
      })
      .catch(this.handleError);
  }

  getSentinelDomainInfo(
    serverid: number,
    domainid: number
  ): Observable<SentinelDomainInfo> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    // WE SHOULD FIX THIS SOON
    // let authToken = localStorage.getItem("auth_token");
    // headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(
        this.baseUrl +
          "/sentinelserver/sentinel_getdomaininfo/" +
          serverid +
          "/" +
          domainid,
        { headers }
      )
      .map((response: Response) => {
        return <SentinelDomainInfo>response.json();
      })
      .catch(this.handleError);
  }

  async ObtenerUltimaCorrida(
    serverid: number,
    domainid: number
  ): Promise<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    // WE SHOULD FIX THIS SOON
    // let authToken = localStorage.getItem("auth_token");
    // headers.append("Authorization", `Bearer ${authToken}`);
    await this.http
    .get(
      this.baseUrl +
        "/sentinelserver/sentinel_getlastrun/" +
        serverid +
        "/" +
        domainid,
      { headers }
    ).subscribe(response =>{
      //console.log("[visualisDataService] res: ", response);
      return response;
    })
  }

  getSentinelDomainLastRun(
    serverid: number,
    domainid: number
  ): Observable<SentinelDomainRun> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    // WE SHOULD FIX THIS SOON
    // let authToken = localStorage.getItem("auth_token");
    // headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(
        this.baseUrl +
          "/sentinelserver/sentinel_getlastrun/" +
          serverid +
          "/" +
          domainid,
        { headers }
      )
      .map((response: Response) => {
        //console.log("[visualisDataService] res: ", response);
        var sentinelDomainRun = <SentinelDomainRun>response.json();
        return sentinelDomainRun;
      })
      .catch(this.handleError);
  }

  getSentinelImgInfo(
    serverid: number,
    domainid: number,
    speciesid: number,
    runid: number
  ): Observable<SentinelImgInfo> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    var url = this.baseUrl + "/sentinelserver/sentinel_getrenderinfo/" + serverid + "/" + domainid + "/" + speciesid + "/" + runid
    // WE SHOULD FIX THIS SOON
    // let authToken = localStorage.getItem("auth_token");
    // headers.append("Authorization", `Bearer ${authToken}`);
    //console.log("Obtaining : ",serverURL+"/static_map/Tiles/si/"+domainid+"/"+speciesid+"/"+runid+"/info.json")

    return this.http
      .get(url
        ,
        { headers }
      )
      .map((response: Response) => {
        //console.log("CarlosCastro. getSentinelImgInfo().",
        //"\n url: ", url,
        //"\n Inputs: ServerId: ", serverid, "; domainId: ", domainid, "; speciesId: ", speciesid, "; RunId: ", runid,
        //"\n Response:", response);
        return <SentinelImgInfo>response.json();
      })
      .catch(this.handleError);
  }

  getSentinelImgFcInfo(
    serverid: number,
    domainid: number,
    speciesid: number,
    runid: number,
    timeid: number
  ): Observable<SentinelImgInfo> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    var url = this.baseUrl + "/sentinelserver/sentinel_getrenderinfo_fc/" + serverid + "/" + domainid + "/" + speciesid + "/" + runid + "/" + timeid;
    return this.http
      .get(url, { headers })
      .map((response: Response) => {
        //console.log("CarlosCastro. getSentinelImgFCInfo()",
        //"\n url: ", url,
        //"\n Inputs: ServerId: ", serverid, "; domainId: ", domainid, "; speciesId: ", speciesid, "; RunId: ", runid, "; timeId", timeid,
        //"\n response: ", response);
        return <SentinelImgInfo>response.json();
      })
      .catch(this.handleError);
  }

  getSentinelForecast(
    serverid: number,
    domainid: number,
    runid: number
  ): Observable<SentinelForecast> {
    let headers = new Headers();
    var url = this.baseUrl + "/sentinelserver/sentinel_getforecast/" + serverid + "/" + domainid + "/" + runid;
    headers.append("Content-Type", "application/json");
    return this.http
      .get(url, { headers })
      .map((response: Response) => {
        //console.log("CarlosCastro. getSentinelForecast()" ,
        //"\n url: ", url,
        //"\n Inputs: ServerId: ", serverid, "; domainId: ", domainid, "; RunId: ", runid,
        //"\n response: ", response);
        return <SentinelForecast>response.json();
      })
      .catch(this.handleError);
  }

  // ==================================================================
  // SystemConfig
  // ==================================================================
  getSystemConfig_String(param: string) {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(this.baseUrl + "/sysconfig/getstring/" + param, { headers })
      .map(response => response.text())
      .catch(this.handleError);
  }

  setSystemConfig_String(param:SysConfig) {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .put(this.baseUrl + "/sysconfig/setstring",param, {
        headers
      })
      .map(response => response.text())
      .catch(this.handleError);
  }

  // ==================================================================
  // iSAP Commands
  // ==================================================================
  sendISAPCommand(isapurl:string,isapid:string,icommand:number,ihours:number) {
    let e = new Date(Date.now() + ihours*3600000);

    let smo = (e.getMonth()+1).toString();
    if (smo.length==1) {
      smo = "0"+smo;
    }

    let sdy = e.getDate().toString();
    if(sdy.length == 1) {
      sdy = "0"+sdy;
    }

    let shr = e.getHours().toString();
    if(shr.length == 1) {
      shr = "0"+shr;
    }

    let smin = e.getMinutes().toString();
    if(smin.length==1) {
      smin = "0"+smin;
    }

    let sdate = e.getFullYear()+smo+sdy+shr+smin;
    let surl = isapurl+"/SAP?name="+isapid+"&set_state="+icommand+"&fechahora="+sdate;

    //console.log("ISAP Command : "+surl);
    return this.http.get(surl).map(response => response.text()).catch(this.handleError);
  }

  // ==================================================================
  // DataExport commands
  // ==================================================================
  getReceptorExportModeled(serverId, domainId, speciesId,from,to): Observable<SentinelDomainExportModeled> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(this.baseUrl + "/component/receptor_export_modeled/" + serverId+"/"+ domainId+"/"+ speciesId+"/"+from+"/"+to, { headers })
      .map((response: Response) => {
        return <SentinelDomainExportModeled>response.json();
      })
      .catch(this.handleError);
  }

  getReceptorAlertReport(serverId, domainId, speciesId,from,to): Observable<SentinelAlertReport> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(this.baseUrl + "/component/receptor_export_alertreport/" + serverId+"/"+ domainId+"/"+ speciesId+"/"+from+"/"+to, { headers })
      .map((response: Response) => {
        return <SentinelAlertReport>response.json();
      })
      .catch(this.handleError);
  }

  getGeolocation(params: any): Observable<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    var _url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${params.address}.json?country=${params.country}&region=${params.region}&district=${params.district}&types=address&access_token=${environment.mapBoxApiToken}`;
    //console.log("debug:getGeolocation", _url);

    return this.http
      .get(_url)
      .map((response: Response) => {
        return <any>response.json();
      })
      .catch(this.handleError);
  }

  // ==================================================================
  // SystemConfig
  // ==================================================================
  getLanguages1() {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(this.baseUrl + "/sysconfig/getstring/Languages", { headers })
      .map(response => response.text())
      .catch(this.handleError);
  }

  getLanguages(): Observable<LanguageConfig> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    return this.http
      .get(
        this.baseUrl +
          "/language/getlist" ,
        { headers }
      )
      .map((response: Response) => {
        return <LanguageConfig>response.json();
      })
      .catch(this.handleError);
  }

  getLanguage(code: string): Observable<Language> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    return this.http
      .get(
        this.baseUrl +
          "/language/get/" + code ,
        { headers }
      )
      .map((response: Response) => {
        return <Language>response.json();
      })
      .catch(this.handleError);
  }

  setLanguages(data: Language[]): Observable<Language> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    return this.http
      .put(
        this.baseUrl +
          "/language/set", data , { headers }
      )
      .map((response: Response) => {
        return response.text;
      })
      .catch(this.handleError);
  }
}

//intentare agregar servicio para ver menu configuraciones
export class BarraConfiguraciones{
  public mostrar: boolean = true;
  updateConfig:EventEmitter<boolean> = new EventEmitter();
  updateConfiguraciones(mostrar) {
    this.mostrar = mostrar;
    this.updateConfig.emit(mostrar);
  }
  Mostrar(){
    this.mostrar = true;
  }
  Ocultar(){
    this.mostrar = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/visualis/services/visualis.data.service.ts